<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" @click.self="close">
      <div
        :class="container_class"
        :style="container_style"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <slot name="header">
          <header :class="header_container_class" :style="header_container_style">
            {{ modal_title }}
            <button
              type="button"
              class="btn-close"
              @click="close"
              aria-label="Close modal"
            >x</button>
          </header>
        </slot>

        <section :class="body_container_class" :style="body_container_style">
          <slot name="body">body</slot>
        </section>
       <!-- <footer :class="footer_container_class" :style="footer_container_style">
          <slot name="footer">
            <button type="button" class="btn-green" @click="close" aria-label="Close modal">Close</button>
          </slot>
        </footer>-->
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "vue-modal",
  props: {
    modal_title: {
      type: String,
      default: ""
    },
    container_class: {
      type: String,
      default: "my-modal"
    },
    container_style: {
      type: String,
      default: ""
    },
    body_container_class: {
      type: String,
      default: "my-modal-body"
    },
    body_container_style: {
      type: String,
      default: ""
    },
    header_container_class: {
      type: String,
      default: "my-modal-header"
    },
    header_container_style: {
      type: String,
      default: ""
    },
    footer_container_class: {
      type: String,
      default: "my-modal-footer"
    },
    footer_container_style: {
      type: String,
      default: ""
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>
<style>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999;
}

.my-modal {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 9999999;
  top: 35px;
}

.my-modal-header,
.my-modal-footer {
  padding: 5px;
  display: flex;
  font-weight: 700;
}

.my-modal-header {
  border-bottom: 1px solid #eeeeee;
  justify-content: space-between;
    background-color: #edeeee;
    font-size: 16px;
}

.my-modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
}

/*.my-modal-body {*/
/*    height: 490px !important;*/
/*}*/

.btn-close {
  border: none;
  font-size: 16px;
  padding: 0px 5px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}
</style>
